import { Stack, Typography } from "@mui/material";
import { useAffiliateEarningsQuery } from "Api/Queries/Lead/useAffiliateEarningsQuery";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { PrimarySkeleton } from "Components/Shared/PrimarySkeleton";
import { Resources, useResource } from "Translations/Resources";
import { formatCurrency } from "Utils/CurrencyUtils";

const RESOURCES = Resources.Components.Affiliate.ThanksToYou.Withdrawn;

/**
 * The Díky Tobě section for a person who left the program for good (ZS-1623): no invitation link,
 * no referrals and — unlike after a refusal — no way back in. What they earned before leaving stays
 * theirs (terms 9.2), so the balance still waiting for a payout is shown; the earnings come from the
 * fee records, which leaving does not touch.
 */
export const ThanksToYouWithdrawnCard = () => {
  const { t } = useResource();
  const { data: earnings, isLoading, isError } = useAffiliateEarningsQuery();

  return (
    <PrimaryPaper>
      <Stack gap={1}>
        <PaperTitle>{t(RESOURCES.Title)}</PaperTitle>
        <Typography>{t(RESOURCES.Text)}</Typography>
        {isLoading && <PrimarySkeleton width="40%" />}
        {isError && <ErrorText>{t(Resources.Error.Unexpected)}</ErrorText>}
        {earnings && (
          <Typography fontWeight={600}>
            {t(RESOURCES.PayoutBalance, {
              amount: formatCurrency({
                amount: earnings.currentPayoutAmount,
                currencyCode: earnings.currentPayoutCurrency,
              }),
            })}
          </Typography>
        )}
      </Stack>
    </PrimaryPaper>
  );
};
